/* eslint-disable no-unused-vars */

import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-upload-image-crop-modal.html";

/**
 * @customElement
 * @polymer
 */
export class NsUploadImageCropModal extends PolymerElement {
  constructor() {
    super();
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get is() {
    return "ns-upload-image-crop-modal";
  }

  ready() {
    super.ready();

    this.toggle = () => {
      this.$.croppie.toggle();
    };

    this.croppieElement = this.$.croppie;

    this.parentComponent = this.parentNode.host;
  }

  _cancelImageCrop() {
    this.parentComponent._cancelImageCrop();
  }

  _handleImageSave() {
    this.parentComponent._handleImageSave();
  }

  rotate(e) {
    let degree = e.currentTarget.dataset.degree * 1;
    this.parentComponent.croppieInstance.rotate(degree);
  }
}

window.customElements.define(NsUploadImageCropModal.is, NsUploadImageCropModal);
